// extracted by mini-css-extract-plugin
export default {"score_table":"CourseScoreCardPopOver_score_table__Z6vV3","color_box":"CourseScoreCardPopOver_color_box__IcVWm","popover_scorecard":"CourseScoreCardPopOver_popover_scorecard__Z-2Sq"};